<script lang="ts">
  import { onMount } from "svelte";
  import { Table } from "../../components/Table";
  import { dossierActivityDtoFields } from "../../utils/TableFields/dossier-activity-dto.fields";
  import {
    initList,
    loading,
    onPageChange,
    pagination,
    records,
  } from "./dossier-activities.store";

  export let oid: number;

  onMount(() => initList(oid));
</script>

<Table
  loading={$loading}
  fields={dossierActivityDtoFields}
  records={$records}
  pagination={$pagination}
  createEnabled={false}
  editEnabled={false}
  deleteEnabled={false}
  exportEnabled={false}
  on:pageChange={(e) => onPageChange(e.detail)}
/>
